import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Typography, Box, useMediaQuery, useTheme } from '@mui/material'
import Parser from 'html-react-parser';

//// import { mainStyles, theme } from '../../styles'
import { useStyles } from './IdentityValidationStyles'
import { documentsActions, fileActions, workflowActions, addTitleLegoCurrent } from '../../store/actions'
import { UseImage, CustomLoadingOverlay, GenericContainer, Buttons, GenericContainerForm } from '../../components'
import { HandType, ApiIdentyUrl, ApiUrl, coreFunctions } from '../../utils'
import Mano_derechaImg from '../../assets/Mano_derecha.jpg'
import Mano_izquierdaImg from '../../assets/Mano_izquierda.jpg'
import { useTranslation } from 'react-i18next';

export default function HelpHandsComponent(props) {
    const matches = useMediaQuery('(min-width:650px)');
    const theme = useTheme()
    const location = useLocation()
    const localStyles = useStyles()
    const navigate = useNavigate()
    const [folioId, setFolioId] = useState(0)
    const [capturedHand, setCapturedHand] = useState(0)
    const [capturedCurrentHand, setCapturedCurrentHand] = useState("")

    const [loadView, setLoadView] = useState(false)
    const [isFlowGroup, setIsFlowGroup] = useState(false)
    const [actorIdCurrent, setActorIdCurrent] = useState(null)
    const [sections, setSections] = useState([])
    const [loadStatusStage, setLoadStatusStage] = useState(false)

    const file = useSelector(state => state.FileInfo)
    const registroStatusStage = useSelector(state => state.RegStatusStage)
    const dispatch = useDispatch()
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        setFolioId(location.state.folioId)
        setCapturedHand(location.state.capturedHand === undefined ? 0 : location.state.capturedHand)
        console.log("location.state.capturedHand---------------------------------:", location.state.capturedHand)
    }, [])


    useEffect(() => {
        capturedHand == 0 ? setCapturedCurrentHand(HandType.LEFT) : setCapturedCurrentHand(HandType.RIGHT)
        dispatch(addTitleLegoCurrent(capturedHand == 0 ? 'Dedos de mano izquierda' : 'Dedos de mano derecha'))
    }, [capturedHand])

    useEffect(() => {
        if (file.items != undefined) {
            setFolioId(file.items.Id)
            let currentActorValue = file.items?.Stage?.CurrentActor?.Id
            console.log("file.items-------------setActorIdCurrent--------------------: ", currentActorValue)
            setActorIdCurrent(currentActorValue)

            const secs = file.items.Stage?.DocumentalCategory?.DocumentalGroups[0]?.DocumentTypes[0]?.Sections
            const sectionsValue = secs?.filter((sec) => sec.CaptureType == "Minutiae")
            console.log("secs-------------sectionsValue---------------------: ", sectionsValue)
            setSections(sectionsValue)

            if (file.items.Product == "Solicitud Grupal") {
                setIsFlowGroup(true)
            }
        }
    }, [file])

    useEffect(() => {
        console.log("registroStatusStage.items------- ", registroStatusStage.items)
        setLoadView(registroStatusStage.loading)
        if (registroStatusStage.items != undefined && registroStatusStage.items != null && loadStatusStage) {
            setLoadStatusStage(false)
            const nextComponent = 'ExternalValidations'
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
        }
    }, [registroStatusStage])

    const handleCapture = () => {
        let skipActor = (isFlowGroup ? null : true)
        let sectionIdValue = capturedHand == 0 ? sections.find(item => item.CaptureOptions == "{\"FingerNumber\":7}")?.Id : sections.find(item => item.CaptureOptions == "{\"FingerNumber\":2}")?.Id

        let wihe = 'width=' + window.screen.availWidth + ',height=' + window.screen.availHeight;
        let win = window.open(`${ApiIdentyUrl.fingerAI}app?params=${folioId}_hand_${capturedHand}_${sectionIdValue}_${skipActor}_${actorIdCurrent}_${encodeURI(ApiUrl.ambient)}_${sessionStorage.getItem('token')}`, '_blank', "screenX=1,screenY=1,left=1,top=1," + wihe);

        let pollTimer = window.setInterval(function () {
            console.log("Espea de cierre de ventana------------------- ", win?.closed)
            if (win.closed != false) { // != is required for compatibility with Opera                
                window.clearInterval(pollTimer);
                if (capturedHand == 1) {
                    dispatch(workflowActions.RegisterStatusStage({
                        File_id: folioId,
                        Status: "Validación"
                    }))
                    setLoadStatusStage(true)
                } else {
                    let nextComponent = 'HelpHandsComponent'
                    let capturedHand = 1
                    coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, capturedHand } })
                    setCapturedHand(1)
                }
            }
        }, 2000);
    }

    const handleNoCapture = () => {
        const nextComponent = 'SkipJustificationHand'
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, capturedHand } })
    }

    return (<GenericContainer>
        <GenericContainerForm>
            {/* <Typography
                variant="h6"
                gutterBottom> <b>{capturedHand == 0 ? 'Dedos de mano izquierda' : 'Dedos de mano derecha'} </b></Typography> */}
            <Typography
                variant={!matches ? "subtitle2" : "subtitle1"}
                gutterBottom>
                {
                    Parser("Junta tus dedos(índice, medio, anular y meñique) y colócalos frente a la camara del teléfono(aproximadamente a ocho centimetros), espera a que enfoque y realiza la captura automáticamente.")
                }
            </Typography>
            <Box style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                width: '100%',
                justifyContent: 'flex-end',
                padding: "1em",
            }}>
                <UseImage src={capturedHand == 0 ? Mano_derechaImg : Mano_izquierdaImg} className={localStyles.imgFinger} />
            </Box>
        </GenericContainerForm>
        <Buttons
            ConfirmButtonText={capturedHand == 0 ? 'Capturar mano izquierda' : 'Captura mano derecha'}
            onClickConfirm={handleCapture}
            CancelButtonText="No capturar"
            onClickCancel={handleNoCapture} />

        {loadView ?
            <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
            : null}
    </GenericContainer>)
}